var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Divider',[_c('div',{staticClass:"videoconsultation-link__divider"},[_vm._v(_vm._s(_vm.$t('documents.link_to_vc')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }